export default function isCompass() {
    if (!window.location.host.match(/\.logcompass\.(com|test)/)) {
        return {
            name: "launch"
        };
    }
}
